import React, { useState, useEffect } from "react";
import { useClass } from "./../../../contexts/classContext";
import { useNavigate } from "react-router-dom";
import LoginService from "./../../../services/auth-service";
import { toast } from "react-toastify";
import ConfigService from "../../../services/config-service";
import { useDispatch, useSelector } from "react-redux";
import UserService from "./../../../services/user-service";
import LoaderOverlay from "./../../common/helper/loader.component.js";
import BadgeAvatars from "../miui-component/avatar.jsx";
import BasicMenu from "../miui-component/menuDropdown.jsx";
import SettingsIcon from "@mui/icons-material/Settings";
import NotificationsIcon from "@mui/icons-material/Notifications";
import ForumOutlinedIcon from "@mui/icons-material/ForumOutlined";

const Header = () => {
  const userData = useSelector((state) => state.authReducer.user);
  const [totalBalance, setTotalBalance] = useState(0);
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();
  const { toggleClass, myClass } = useClass();
  const redirect = () => {
    navigate("/");
  };
  const updateProfile = () => {
    navigate("/update-profile");
  };

  const notifications = () => {
    navigate("/notifications");
  };

  
  console.log(myClass, "customClass ");
  return (
    <>
      <LoaderOverlay loading={loading} />
      <nav className="sb-topnav navbar navbar-expand navbar-light">
        {/* <a
          className="navbar-brand"
          id="dfgreegdgf"
          href="#"
        >
          
        </a> */}
       
        {/* <div className="d-none d-md-block">
          <p className="mb-0 fs-4 ms-5" style={{ fontWeight: 600 }}>Dashboard</p>
          
        </div> */}
        <div className="ms-4">
          <button
            onClick={toggleClass}
            className="h-100 btn btn-link btn-sm order-1 order-lg-0 me-4 me-lg-0 fside"
            id="sidebarToggle"
            href="#!"
          >
            {myClass !== "customClass" ? (
              <div>
                <i className="fa fa-bars fs-5" />
              </div>
            ) : (
              <div>
                <i class="fa fa-times fs-5"></i>
              </div>
            )}
          </button>
        </div>
        <ul className="navbar-nav ms-auto me-4 h-100">
          <li className="align-self-center me-3 d-none d-md-block">
            <div
              style={{
                padding: "10px",
                borderRadius: "18px",
                backgroundColor: "white",
                color: "#495A69",
              }}
            >
              <NotificationsIcon sx={{ width: "30px", height: "30px" }} />
            </div>
          </li>
          <li className="align-self-center me-3 d-none d-md-block">
            <div
              style={{
                padding: "10px",
                borderRadius: "18px",
                backgroundColor: "white",
                color: "#495A69",
              }}
            >
              <ForumOutlinedIcon sx={{ width: "30px", height: "30px" }} />
            </div>
          </li>
          <li className="align-self-center me-5 d-none d-md-block">
            <div
              style={{
                padding: "10px",
                borderRadius: "18px",
                backgroundColor: "white",
                color: "#495A69",
              }}
            >
              <SettingsIcon sx={{ width: "30px", height: "30px" }} />
            </div>
          </li>
          <li className={`nav-item align-self-center me-3 avatar-header`}>
            <BasicMenu  totalBalance={totalBalance}>
              <BadgeAvatars userName={userData?.data?.full_name}/>
            </BasicMenu>
          </li>
          {/* <li className={`nav-item dropdown cdf align-self-center`}>
            <BasicMenu
              title={userData?.data?.full_name}
              menuItem={[
                { label: "Update Profile", callBackFun: updateProfile },
                { label: "Logout", callBackFun: logout },
              ]}
            />
          </li> */}
        </ul>
      </nav>
    </>
  );
};
export default Header;
// }
// function mapStateToProps(state) {
// 	// console.log(state)
// 	 const userData = state.authReducer.user;
// 	 return { userData };
//    }
//    export default connect(mapStateToProps)(Header);
